<template>
  <div class="tinymce-editor">
    <Editor v-model="myValue"
      :init="init"
      :disabled="disabled"
      @onClick="onClick">
    </Editor>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/textcolor';
import { API_IMG_UPLOAD, API_IMG_DOWNLOAD } from '@/common/constants';

export default {
    components: {
        Editor
    },
    props: {
        height: {
            type: Number,
            default: 300
        },
        // 传入一个value，使组件支持v-model绑定
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        plugins: {
            type: [String, Array],
            default: 'image table lists contextmenu wordcount colorpicker textcolor'
        },
        toolbar: {
            type: [String, Array],
            default: 'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat'
        }
    },
    data () {
        return {
            // 初始化配置
            init: {
                base_url: 'https://www.bcbpm.com/static/file/tinymce',
                language_url: 'https://www.bcbpm.com/static/file/tinymce/langs/zh_CN.js',
                language: 'zh_CN',
                skin_url: 'https://www.bcbpm.com/static/file/tinymce/skins/ui/oxide',
                height: this.height,
                browser_spellcheck: true, // 拼写检查
                branding: false, // 去水印
                // elementpath: false,  //禁用编辑器底部的状态栏
                statusbar: false, // 隐藏编辑器底部的状态栏
                paste_data_images: true, // 允许粘贴图像
                menubar: false, // 隐藏最上方menu
                plugins: this.plugins,
                toolbar: this.toolbar,
                image_description: false,
                image_dimensions: false, // 隐藏图片长宽设置
                // image_uploadtab: false,//上传tab
                // image_advtab:true,//图片上传高级设置
                // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
                // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
                images_upload_handler: (blobInfo, success, failure) => {
                    // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
                    // success(img)
                    var xhr, formData;
                    xhr = new XMLHttpRequest();
                    xhr.withCredentials = false;
                    xhr.open('POST', API_IMG_UPLOAD);
                    xhr.onload = function () {
                        var json;
                        if (xhr.status != 200) {
                            failure('HTTP Error: ' + xhr.status);
                            return;
                        }
                        json = JSON.parse(xhr.responseText);
                        var imagePath = json.data[0].filePath;
                        var imageUrl = `${API_IMG_DOWNLOAD}${imagePath}`;
                        success(imageUrl);
                    };
                    formData = new FormData();
                    formData.append('file', blobInfo.blob(), blobInfo.filename());
                    xhr.send(formData);
                }
            },
            myValue: this.value
        };
    },
    mounted () {
        tinymce.init({});
    },
    methods: {
        // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
        // 需要什么事件可以自己增加
        onClick (e) {
            this.$emit('onClick', e, tinymce);
        },
        // 可以添加一些自己的自定义事件，如清空内容
        clear () {
            this.myValue = '';
        }
    },
    watch: {
        value (newValue) {
            this.myValue = newValue;
        },
        myValue (newValue) {
            this.$emit('input', newValue);
        }
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Tinymce/Tinymce.vue